import context from "../../../_app/context";
import {redirect} from "react-router-dom";

export const authLayoutLoader = async (params) => {
    if(context.admin())  {
        return redirect(context.route("cms.Dashboard"));
    }
    return null;
}
